import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() => ({
  link: {
    padding: 30,
    position: 'relative',
    paddingLeft: 100,
    paddingTop: 20,
    display: 'inline-block',
    color: 'black!important',
    '&:hover': {
      '& $box': {
        background: 'lightgrey'
      }
    }
  },
  box: {
    border: '1px solid black',
    display: 'inline-box',
    padding: 15,
    position: 'absolute',
    left: 15,
    background: 'white'
  },
  bignum: {
    fontSize: 35,
    fontWeight: 'lighter'
  },
  bugNumUnread: {
    fontWeight: 'normal'
  },
  // bignumactive: {
  //   fontSize: 35,
  //   fontWeight: 'bold'
  // },
  dtext: {
    fontWeight: 'bold',
  },
}))
